import { local_storage_keys } from '@/shahrzad-assets/shared-constants/localstorage'
import * as React from 'react'
import { useState, useEffect } from 'react'

export const QrCodeContext = React.createContext({
  code: {},
  setCode: (key: any) => {},
})

const QrCodeContextProvider = (props: any) => {
  const locale_data = JSON.parse(
    localStorage.getItem(local_storage_keys.QR_CODE_CONTEXT) ?? '{}',
  )
  const [code, setCode] = useState<any>(locale_data.code ?? {})

  const qrCodeContext = {
    code: code,
    setCode: setCode,
  }

  useEffect(() => {
    const data_storage = {
      code,
    }
    localStorage.setItem(
      local_storage_keys.QR_CODE_CONTEXT,
      JSON.stringify(data_storage),
    )
  }, [code])

  return (
    <QrCodeContext.Provider value={qrCodeContext}>
      {props.children}
    </QrCodeContext.Provider>
  )
}

export default QrCodeContextProvider
